export default "/fonts/vendor/material-icons/iconmaterial-icons-sharp.woff2?219aa9140e099e6c72ed886f739033e0";